export const EHR_PAGE_PATH = '/patient/:patientId';
export const ENTRY_PAGE_PATH = '/patient/:patientId/entry/:entryId';
